import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Layout } from "../components/Navbar";
import { api, getUser } from "../api";

export default function Events() {
  const { t, i18n } = useTranslation();
  const u = getUser();
  const [params] = useSearchParams();
  const orgId = params.get("organization_id");
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    // Filtro server-side: organization_id passato come parametro query all'API
    api.get("/events", { params: orgId ? { organization_id: orgId } : {} })
      .then(({data}) => setEvents(data))
      .finally(() => setLoaded(true));
  }, [orgId]);
  const orgName = events[0]?.organizer_name;
  const fmtDay = (e) => {
    const first = e.slots?.[0]?.start_at;
    return first ? new Date(first).toLocaleString(i18n.language, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : null;
  };
  return (<Layout><div className="yp-container py-8" data-testid="events-page">
    <div className="flex justify-between items-start mb-6 gap-3 flex-wrap">
      <div>
        <h1 className="text-3xl font-bold" data-testid="events-title">{orgId ? t("orgd.events_of") : t("events.title")}</h1>
        {orgId && orgName && <p className="text-slate-500 mt-1" data-testid="events-org-name">{orgName}</p>}
      </div>
      {u?.role === "organization" && <div className="flex gap-2">
        <Link to="/my-events" className="yp-btn yp-btn-outline" data-testid="my-events-link">{t("events.my_events")}</Link>
        <Link to="/events/create" className="yp-btn yp-btn-primary" data-testid="event-create-btn">+ {t("events.create")}</Link>
      </div>}
    </div>
    {loaded && events.length === 0 && (
      <div className="yp-card p-6 text-center" data-testid="events-empty">
        <p className="text-slate-500">{orgId ? t("orgd.none_for_org") : t("events.empty")}</p>
        {orgId && <Link to={`/organizations/${orgId}`} className="yp-btn yp-btn-outline mt-4 inline-block" data-testid="back-to-org-btn">{t("orgd.back_to_org")}</Link>}
      </div>)}
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
      {events.map(e => (
        <div key={e.id} className="yp-card overflow-hidden yp-gradient-border flex flex-col" data-testid="event-card">
          {e.image_url && <img src={e.image_url} alt="" className="w-full h-36 object-cover" loading="lazy" />}
          <div className="p-5 flex flex-col flex-1">
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-bold">{e.title}</h3>
              {orgId && e.availability && (
                <span className={`yp-badge shrink-0 ${e.availability === "open" ? "yp-badge-approved" : "yp-badge-pending"}`} data-testid="event-availability">
                  {t(`events.avail_${e.availability === "open" ? "open" : "full"}`)}
                </span>)}
            </div>
            <p className="text-sm text-slate-600 mt-2 line-clamp-3">{e.description}</p>
            <div className="text-xs text-slate-500 mt-3 space-y-1">
              {fmtDay(e) && <div>🕒 {fmtDay(e)}</div>}
              <div>📍 {e.address}</div>
              {e.organizer_name && <div>🏥 {e.organizer_name}</div>}
              {!orgId && <div>🕒 {e.slots?.length || 0} {t("events.slots").toLowerCase()}</div>}
            </div>
            <Link to={`/events/${e.id}`} className="yp-btn yp-btn-outline mt-4 text-center" data-testid="event-view-btn">{t("orgd.view_event")}</Link>
          </div>
        </div>))}
    </div>
  </div></Layout>);
}
